<template>
  <div class="department-info-block">
    <AppLoader v-if="loading" />
    <p v-else-if="loadError" class="department-info-block__error text-circe-18 color-gray">
      Не удалось загрузить информацию об отделении
    </p>
    <p v-else-if="!departmentName" class="department-info-block__error text-circe-18 color-gray">
      Выберите отделение в редакторе страницы
    </p>
    <template v-else-if="isPageMode && departmentInfo">
      <div class="general-info">
        <div class="general-info__container">
          <nav aria-label="breadcrumbs">
            <ol class="breadcrumbs">
              <li class="breadcrumb-item">
                <router-link to="/" class="text-TTDrugs-regular-14 color-gray">
                  Главная<img src="../../assets/svg/arrow-mini.svg" alt="" />
                </router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/department2" class="text-TTDrugs-regular-14 color-gray">
                  Отделения<img src="../../assets/svg/arrow-mini.svg" alt="" />
                </router-link>
              </li>
              <li class="breadcrumb-item">
                <span class="text-TTDrugs-regular-14 color-gray">{{ departmentInfo.title }}</span>
              </li>
            </ol>
          </nav>
          <div class="general-info__title-left">
            <h1 class="text-TTDrugs-Bold-40 color-green center text-uppercase">
              {{ departmentInfo.title }}
            </h1>
          </div>
          <div class="under-department-content">
            <div
              class="under-department-content__first-block"
              v-html="departmentInfo.content"
            />
            <div class="under-department-content__second-block">
              <div
                v-if="departmentInfo.image"
                class="under-department-content__second-block-image"
              >
                <AppImageLoader
                  :src="departmentInfo.image"
                  class="under-department-content__image"
                />
              </div>
              <div
                class="under-department-content__second-block-text"
                v-html="departmentInfo.contentTwo"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
    <AppVacancyDepartmentInfo
      v-else-if="departmentInfo"
      :department-info="departmentInfo"
      :heading="data.heading"
    />
  </div>
</template>

<script>
import DepartmentAPi from "@/api/department";
import AppVacancyDepartmentInfo from "@/components/Vacancies/VacancyDepartmentInfo.vue";
import AppLoader from "@/components/Loader.vue";
import AppImageLoader from "@/components/ImageLoader.vue";

function extractDepartmentInfo(res) {
  const body = res && res.data !== undefined ? res.data : res;
  if (body && body.status === "SUCCESS" && body.result) {
    return body.result;
  }
  if (body && typeof body === "object" && !Array.isArray(body)) {
    return body;
  }
  return null;
}

export default {
  name: "AppDepartmentInfoBlock",
  components: { AppVacancyDepartmentInfo, AppLoader, AppImageLoader },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
      loadError: false,
      departmentInfo: null,
    };
  },
  computed: {
    departmentName() {
      return String(this.data.subDepartmentName || "").trim();
    },
    isPageMode() {
      return String(this.data.displayMode || "vacancy") === "page";
    },
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.loadDepartmentInfo();
      },
    },
  },
  mounted() {
    this.loadDepartmentInfo();
  },
  methods: {
    async loadDepartmentInfo() {
      if (!this.departmentName) {
        this.loading = false;
        this.loadError = false;
        this.departmentInfo = null;
        return;
      }

      this.loading = true;
      this.loadError = false;

      try {
        const response = await DepartmentAPi.getItemUnderDepartment(this.departmentName);
        this.departmentInfo = extractDepartmentInfo(response);
        if (!this.departmentInfo) {
          this.loadError = true;
        }
      } catch (e) {
        this.loadError = true;
        this.departmentInfo = null;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.department-info-block {
  width: 100%;
}

.department-info-block__error {
  padding: 16px 0;
}

.breadcrumbs {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
  margin: 0 0 16px;
  gap: 4px;
}

.breadcrumb-item {
  display: inline-flex;
  align-items: center;

  img {
    margin-left: 4px;
    vertical-align: middle;
  }
}
</style>
